import { Grid } from "@mui/material";
import { FC } from "react";
import Ellipsis from "@src/components/shared-ui-components/Ellipsis";
import CustomIconButton from "@src/components/shared-ui-components/CustomIconButton";
import { StyledLocationBox, StyledTypography } from "./styles";

interface CustomButtomType {
  value: string;
  handleButtonClick: () => void;
  icon: string;
  label: string;
  isDesktop: boolean;
}

const CustomButtom: FC<CustomButtomType> = ({
  value,
  handleButtonClick,
  icon,
  label,
  isDesktop,
}) => {
  return (
    <Grid style={{ padding: isDesktop ? 0 : 8 }} xs={6} item>
      <StyledLocationBox onClick={handleButtonClick}>
        <StyledTypography>
          <Ellipsis width={110}>{value}</Ellipsis>
        </StyledTypography>
        <CustomIconButton
          className="icon"
          handleClick={handleButtonClick}
          icon={icon}
          ariaLabel={label}
        />
      </StyledLocationBox>
    </Grid>
  );
};

export default CustomButtom;
